// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"container_4moiL","content":"content_feLng","footer":"footer_ureQL","moreBtn":"moreBtn_zUVAc"};